import angular from 'angular';

angular.module('cloudX').directive('cxTagSelect', [
  function() {
    return {
      restrict: 'E',
      template:
        '<a href="#" editable-select="value" onbeforesave="save({newValue:$data})" e-placeholder="---" e-ng-options="item for item in tags" onshow="loadTags()">' +
        '<span ng-show="value">{{value}}</span><i class="glyphicon glyphicon-pencil" ng-show="!value"></i>' +
        '</a>',
      scope: {
        value: '=data',
        save: '&',
      },
      controller: [
        '$scope',
        'resourceFactorySvc',
        function($scope, resourceFactorySvc) {
          $scope.tags = [];
          $scope.loadTags = function() {
            return $scope.tags.length
              ? null
              : resourceFactorySvc.get('resource').tags({}, function(data) {
                  $scope.tags = data.map(x => x.name);
                }).$promise;
          };
        },
      ],
    };
  },
]);
